import type { RouteRecordRaw } from 'vue-router'

import { billingReturnRoutes } from '@/features/credits'
import { integrationCallbackRoutes, slackCallbackRoutes } from '@/features/integrations'

// The external-return surface (contract 05 §11/§18, ORP-18611). §18 RESOLVED the callback split:
// provider returns (Shopify/OAuth/Stripe — v3 `beforeEach` branches 12–17, 21–24) land on
// dedicated `blank` routes rather than `?query` branches on an arbitrary route, while
// `useQueryCallbacks` keeps only legacy overlap and in-app deep links.
//
// This parent owns the ONE thing the shell decides for every provider return — `layout: 'blank'`,
// inherited by children through vue-router's matched-meta merge. It deliberately owns no auth
// policy: a Shopify return arrives unauthenticated (v3 set the token FROM the callback) while a
// billing return does not, so each child declares its own `requiresAuth`.
//
// Children are contributed by their owning feature on its own ticket (12 → `/callback/shopify`,
// `/callback/oauth`; 11 → the billing return) — the shell composes a feature's exported route
// records and never reaches into its flows. 12's Slack install return is the first to land
// (ORP-19904); until the rest arrive `/callback/<anything-else>` still falls through to the
// catch-all like any unknown path.
export const callbackRoutes: RouteRecordRaw[] = [
  {
    path: '/callback',
    // `mcpAllowed`: an MCP-only user connects the SAME ad accounts through the SAME OAuth flows.
    // Without the flag the MCP redirect branch (ORP-21656) would bounce every provider return
    // before its handler ran, stranding a half-finished connection (contract 05 §18).
    meta: { layout: 'blank', mcpAllowed: true },
    children: [...integrationCallbackRoutes, ...slackCallbackRoutes],
  },
  ...billingReturnRoutes,
]
